import { Component, type ReactNode } from "react";

interface State {
  error: Error | null;
}

export default class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error) {
    console.error("[App Error]", error);
  }

  reset = () => this.setState({ error: null });

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="min-h-screen bg-[#020617] flex flex-col items-center justify-center gap-6 p-6 text-center">
        <div className="text-4xl">😵</div>
        <div>
          <p className="text-white font-bold text-lg mb-1">エラーが発生しました</p>
          <p className="text-slate-400 text-sm">しばらくしてからもう一度お試しください</p>
        </div>
        <button
          onClick={this.reset}
          className="bg-blue-600 text-white font-bold px-6 py-3 rounded-2xl active:scale-95 transition-transform"
        >
          再試行する
        </button>
      </div>
    );
  }
}
